export enum LoadingState {
   FINISHED = 'FINISHED',
   LOADING_ALL = 'LOADING_ALL',
   LOADING_MORE = 'LOADING_MORE',
}